import * as React from "react";
import { BaseComponent } from "../../../../../react-core/Html/BaseComponent";
import { Lightbox } from "../../../../../react-core/Html/Components/Lightbox";
import { PartLoading } from "../../../../../react-core/Html/PartLoading";
import { TextBoxEditor } from "../../../../../react-core/Html/TextBoxEditor";
import { AccountRoleActorCategory } from "../../../../../Wrap/Constants/Enums/AccountRoleActorCategory";
import { RelationshipType } from "../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { TrustAuthorisationRequestType } from "../../../../../Wrap/Constants/Enums/Customer/TrustAuthorisationRequestType";
import { HierarchyLevelName } from "../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { BulkTrustMemberHistorySearchResult } from "../../../../../Wrap/Models/Models/Customer/BulkTrustMemberHistorySearchResult";
import { FullClientDetailModel } from "../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { OrganisationMember } from "../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { Organisation } from "../../../../../Wrap/Models/Models/Customer/Organisation";
import { TrustServicingModel } from "../../../../../Wrap/Models/Models/Customer/TrustServicingModel";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../Urls";
import { DeleteLightbox } from "../../../Common/DeleteLightbox";
import { OrganisationMemberPopUpInfo } from "../AddClient/Resource/Contents";
import { SectionHeader } from "../Common/SharedComponents";
import { NewBusinessAction } from "../NewBusinessWizard/Actions/NewBusinessAction";
import { ClientRecordAction } from "./Action/ClientRecordAction";
import { AddTrustMemberAction } from "./AddTrustMember/Action/AddTrustMemberAction";
import { AddNewButton } from "./Components/AddNewButton";
import { EditBeneficiaryLightbox } from "./Components/TrustMember/EditBeneficiaryLightbox";
import { EditRolesLightbox } from "./Components/TrustMember/EditRolesLightbox";
import { RemoveMemberLightbox } from "./Components/TrustMember/RemoveMemberLightbox";
import { TrustMemberHistoryLightbox } from "./Components/TrustMember/TrustMemberHistoryLightbox";
import { TrustMemberTable } from "./Components/TrustMember/TrustMemberTable";
import { IClientTabProps, PendingMembersWarningMessage } from "./Resource/Contents";
import { ShareofTrustLightbox } from "../../../../Dashboard/Components/Clients/ClientRecord/Components/TrustMember/ShareofTrustLightbox";
import { AccountRoleStore } from "../../../../Dashboard/Components/Clients/ClientRecord/Store/Variable";
import { RoleType } from "../../../../../Wrap/Constants/Enums/RoleType";
import { getQueryParameters } from "../../../../../applications/Shared/Wizards/Entities/QueryParametersHelper";
import { checkPermission } from "../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";

interface ITrustServicingState {
    model: TrustServicingModel;
    showDeleteLightbox: boolean;
    showEditLightbox: boolean;
    showEditRoleLightbox: boolean;
    showHistoryLightbox: boolean;
    editItem: OrganisationMember;
    deleteItem: OrganisationMember;
    selectedItem: OrganisationMember;
    showCorrespondenceWarningLightbox: boolean;
    showAddAbsoluteBeneficiaryWarningLightbox: boolean;
    pendingActionWarningMessage: string;
    showInactiveMemberWarningLightbox: boolean;
    histories: Array<BulkTrustMemberHistorySearchResult>;
    showHistoryLoading: boolean;
    showRemoveLastTrusteeWaringLighBox: boolean;
    showRemoveLastTrusteeAndCorrespondenceWarningLightbox: boolean;
    showAtLeastOneBeneficiaryWarningLightbox: boolean;
    showShareofTrustLightbox: boolean;
    accountId: number;
}

export class TrustServicing extends BaseComponent<IClientTabProps, ITrustServicingState> {
    constructor(props: IClientTabProps) {
        super(props);
        this.state = {
            model: null,
            showDeleteLightbox: false,
            deleteItem: null,
            showEditLightbox: false,
            showEditRoleLightbox: false,
            showHistoryLightbox: false,
            editItem: null,
            selectedItem: null,
            showCorrespondenceWarningLightbox: false,
            showAddAbsoluteBeneficiaryWarningLightbox: false,
            pendingActionWarningMessage: null,
            showInactiveMemberWarningLightbox: false,
            histories: [],
            showHistoryLoading: true,
            showRemoveLastTrusteeWaringLighBox: false,
            showRemoveLastTrusteeAndCorrespondenceWarningLightbox: false,
            showAtLeastOneBeneficiaryWarningLightbox: false,
            showShareofTrustLightbox: false,
            accountId: null,
        };
        this.subscribeToStore(AccountRoleStore, () => {
            const result = (AccountRoleStore.getData() || []).filter(
                (ele) => ele.AccountRoleType == RoleType.TrustAccountHolder
            );
            if (result.length > 0) {
                this.setState({
                    accountId: result[0].AccountId,
                });
            }
        });
    }
    componentDidMount() {
        AddTrustMemberAction.getTrustServicingModel(Number(this.props.id), (result) => {
            this.setState({ model: result });
            this.getHistories();
        });
    }

    private getData() {
        this.setState({ model: null });
        AddTrustMemberAction.getTrustServicingModel(Number(this.props.id), (result) => {
            this.setState({ model: result });
            this.getHistories();
        });
    }

    private getHistories() {
        const { model } = this.state;
        if (model && model?.HierarchyId?.EntityId) {
            this.setState({ showHistoryLoading: true });
            const memberIds = model.Organisation?.OrganisationMembers?.map((x) => x.CustomerId);
            const invalidMemberIds = model?.InactiveMembers?.map((x) => x.CustomerId);
            const ids = memberIds.concat(invalidMemberIds);
            AddTrustMemberAction.bulkGetTrustMemberHistory(
                ids,
                model?.Organisation?.CustomerId,
                model?.HierarchyId?.EntityId,
                (data) => {
                    this.setState({ histories: data, showHistoryLoading: false });
                }
            );
        }
    }
    private closeDeleteLightbox = () => {
        this.setState({ showDeleteLightbox: false, deleteItem: null });
    };

    private closeEditLightbox = () => {
        this.setState({ showEditLightbox: false, editItem: null });
    };

    private closeEditRoleLightbox = () => {
        this.setState({ showEditRoleLightbox: false, editItem: null });
    };

    private onDeleteRelationship = () => {
        ClientRecordAction.removeRelationship(
            Number(this.props.id),
            this.state.deleteItem?.CustomerId,
            this.state.deleteItem.Relationships,
            () => {
                this.closeDeleteLightbox();
                this.getData();
            }
        );
    };

    private onEditBeneficiary = (data: FullClientDetailModel) => {
        NewBusinessAction.saveCCMDetail(this.state.editItem?.CustomerId, data, () => {
            this.closeEditLightbox();
            this.getData();
        });
    };

    private onEditRoles = (data: OrganisationMember, newRelationships: RelationshipType[]) => {
        ClientRecordAction.editRelationship(
            Number(this.props.id),
            data?.CustomerId,
            data?.Relationships,
            newRelationships,
            () => {
                this.closeEditRoleLightbox();
                this.getData();
            }
        );
    };

    private renderRelationshipRemove = () => {
        const data = (this.state.model?.Organisation?.OrganisationMembers || []).filter(
            (ele) => !ele.Relationships.includes(RelationshipType.CorporateTrustee)
        );
        return (
            <>
                <p>Are you sure?</p>
                {this.state.deleteItem?.Relationships.includes(RelationshipType.Settlor) &&
                    data.filter((ele) => {
                        return ele.Relationships.includes(RelationshipType.Settlor);
                    }).length == 1 && (
                        <p>{OrganisationMemberPopUpInfo.line2} A settlor will be required if this is a 'New' Trust.</p>
                    )}
                {this.state.deleteItem?.Relationships.includes(RelationshipType.Beneficiary) &&
                    data.filter((ele) => {
                        return ele.Relationships.includes(RelationshipType.Beneficiary);
                    }).length == 1 && <p>{OrganisationMemberPopUpInfo.noBeneficiary}</p>}
            </>
        );
    };

    private onClickDelete(member: OrganisationMember, isRemoveBeneficiary: boolean) {
        const { model } = this.state;
        const pendingAction = model?.MembersWithPendingAction?.find((x) => x?.CustomerId == member?.CustomerId);
        const pendingDeath = model?.MembersPendingDeath?.find((x) => x?.CustomerId == member?.CustomerId);
        const trustees = model?.Organisation?.OrganisationMembers?.filter((x) =>
            x.Relationships?.some(
                (y) => y == RelationshipType.IndividualTrustee || y == RelationshipType.CorporateTrustee
            )
        );

        const trusteeWithNoPendingAction = trustees?.filter(
            (x) =>
                model?.MembersPendingDeath?.every((y) => y.CustomerId != x.CustomerId) &&
                model?.MembersWithPendingAction?.every((y) => y.CustomerId != x.CustomerId)
        );
        if (!model?.HasTrustAccount) {
            this.setState({ showDeleteLightbox: true, deleteItem: member });
        } else {
            if (
                model?.AccountCorrespondenceRecipient?.ActorId == member.CustomerId &&
                trusteeWithNoPendingAction?.length == 1 &&
                trusteeWithNoPendingAction[0]?.CustomerId == member?.CustomerId
            ) {
                this.setState({ showRemoveLastTrusteeAndCorrespondenceWarningLightbox: true });
            } else if (
                trusteeWithNoPendingAction?.length == 1 &&
                trusteeWithNoPendingAction[0]?.CustomerId == member?.CustomerId
            ) {
                this.setState({ showRemoveLastTrusteeWaringLighBox: true });
            } else if (model?.AccountCorrespondenceRecipient?.ActorId == member.CustomerId) {
                //show warning message when member is a corresopendence recipient
                this.setState({ showCorrespondenceWarningLightbox: true });
            } else if (pendingAction?.Type == TrustAuthorisationRequestType.AddAsTrustee) {
                this.setState({ pendingActionWarningMessage: PendingMembersWarningMessage.pendingAdd });
            } else if (pendingAction?.Type == TrustAuthorisationRequestType.RemoveAsTrustee) {
                this.setState({ pendingActionWarningMessage: PendingMembersWarningMessage.pendingRemoval });
            } else if (pendingDeath) {
                this.setState({ pendingActionWarningMessage: PendingMembersWarningMessage.pendingDeath });
            } else if (
                isRemoveBeneficiary &&
                model?.TrustDetail?.TrustCategory == "Flexible" &&
                this.isLastBeneficiary()
            ) {
                this.setState({ showAtLeastOneBeneficiaryWarningLightbox: true });
            } else {
                this.setState({ showDeleteLightbox: true, deleteItem: member });
            }
        }
    }

    private isLastBeneficiary() {
        const { model } = this.state;
        const data = (model?.Organisation?.OrganisationMembers || []).filter((ele) =>
            ele.Relationships.includes(RelationshipType.Beneficiary)
        );

        return data.length <= 1;
    }

    private onClickHistory(member: OrganisationMember) {
        this.setState({ showHistoryLightbox: true, selectedItem: member });
    }

    private onClickShareofTrust() {
        this.setState({ showShareofTrustLightbox: true });
    }
    private onCloseShareofTrust() {
        this.setState({ showShareofTrustLightbox: false });
    }

    private onShareofTrust = (data: Organisation) => {
        AddTrustMemberAction.addTrustMembers(data, (data) => {
            this.setState({ showShareofTrustLightbox: false });
        });
    };

    render() {
        const {
            showDeleteLightbox,
            showEditLightbox,
            editItem,
            showEditRoleLightbox,
            showCorrespondenceWarningLightbox,
            model,
            showAddAbsoluteBeneficiaryWarningLightbox,
            showInactiveMemberWarningLightbox,
            pendingActionWarningMessage,
            showHistoryLightbox,
            selectedItem,
            showRemoveLastTrusteeWaringLighBox,
            showRemoveLastTrusteeAndCorrespondenceWarningLightbox,
            showAtLeastOneBeneficiaryWarningLightbox,
            showShareofTrustLightbox,
        } = this.state;
        if (!model) {return <PartLoading isLoading={true} />;}
        const organisation = JSON.parse(JSON.stringify(model?.Organisation));
        const trustMemberData = (model?.Organisation?.OrganisationMembers.concat(model?.InactiveMembers) || []).filter(
            (ele) =>
                !ele.Relationships.includes(RelationshipType.CorporateTrustee) &&
                ele.Individual?.ActorCategory == AccountRoleActorCategory.Customer
        );
        trustMemberData.forEach((member) => {
            const pending = (model?.MembersWithPendingAction || []).find((ele) => ele.CustomerId == member.CustomerId);
            if (
                pending &&
                pending.Type == TrustAuthorisationRequestType.AddAsTrustee &&
                !member.Relationships.includes(RelationshipType.IndividualTrustee)
            ) {
                member.Relationships = [RelationshipType.IndividualTrustee].concat(member.Relationships);
                (member as any).HasPending = true;
            }
        });
        const trustees = model?.Organisation?.OrganisationMembers?.filter((x) =>
            x.Relationships?.some(
                (y) => y == RelationshipType.IndividualTrustee || y == RelationshipType.CorporateTrustee
            )
        );
        const trusteeWithNoPendingAction = trustees?.filter(
            (x) =>
                model?.MembersPendingDeath?.every((y) => y.CustomerId != x.CustomerId) &&
                model?.MembersWithPendingAction?.every((y) => y.CustomerId != x.CustomerId)
        );
        return (
            <>
                <div className="mb-20">
                    {SectionHeader("Trust Servicing")}
                    <TextBoxEditor
                        disabled={true}
                        label="Trust name"
                        required="Please enter email address"
                        value={this.state.model.Organisation.Name}
                        onChange={(v) => {}}
                    />
                </div>
                <div className="flex-space">
                    {SectionHeader("Trust Members")}
                    {model?.Organisation?.OrganisationMembers?.length < 20 &&
                        this.props.hasReadWriteAccess == true &&
                        checkPermission(UserClaim.AdviserPortalNewClientReadWrite) && (
                            <div className="mb-20">
                                <AddNewButton
                                    name="Add new trust member"
                                    onClick={() => {
                                        Navigator.navigateTo(Urls.get().AddTrustMember, {
                                            scrollAfterNavigating: true,
                                            queryParamsObject: { customerid: this.props.id },
                                        });
                                    }}
                                />
                            </div>
                        )}
                </div>
                <TrustMemberTable
                    data={(model?.Organisation?.OrganisationMembers.concat(model?.InactiveMembers) || []).filter(
                        (ele) =>
                            !ele.Relationships.includes(RelationshipType.CorporateTrustee) &&
                            ele.Individual?.ActorCategory == AccountRoleActorCategory.Customer
                    )}
                    type={model?.Organisation?.CustomerType}
                    trustCategory={model?.TrustDetail?.TrustCategory}
                    hasAction={this.props.hasReadWriteAccess == true}
                    isCompanyMember={false}
                    isBeneficiaryOnly={false}
                    onDelete={(id) => this.onClickDelete(id, false)}
                    onEdit={(id) => {}}
                    onEditRoles={(id) => {
                        this.setState({ showEditRoleLightbox: true, editItem: id });
                    }}
                    showShareOfTrust={true}
                    onClickHistory={(id) => this.onClickHistory(id)}
                    onClickShareofTrust={() => this.onClickShareofTrust()}
                    title={"Individual members"}
                    hasTrustAccount={model?.HasTrustAccount}
                    isTrustServicing={true}
                    histories={this.state.histories}
                    invalidMembers={model?.InactiveMembers}
                    totalTrustees={(trusteeWithNoPendingAction || []).length}
                />
                <br />
                <TrustMemberTable
                    data={(
                        model?.Organisation?.OrganisationMembers.concat(model?.InactiveMembers) || []
                    ).filter((ele) => ele.Relationships.includes(RelationshipType.CorporateTrustee))}
                    type={model?.Organisation?.CustomerType}
                    trustCategory={model?.TrustDetail?.TrustCategory}
                    isCompanyMember={true}
                    isBeneficiaryOnly={false}
                    hasAction={this.props.hasReadWriteAccess == true}
                    onDelete={(id) => this.onClickDelete(id, false)}
                    onEdit={(id) => {}}
                    onEditRoles={(id) => {}}
                    onClickHistory={(id) => this.onClickHistory(id)}
                    onClickShareofTrust={() => {}}
                    title={"Corporate members"}
                    hasTrustAccount={model?.HasTrustAccount}
                    isTrustServicing={true}
                    showShareOfTrust={true}
                    histories={this.state.histories}
                    invalidMembers={model?.InactiveMembers}
                    totalTrustees={(trusteeWithNoPendingAction || []).length}
                />
                <hr />
                <div className="flex-space">
                    {SectionHeader("Additional beneficiaries")}
                    {model?.Organisation?.OrganisationMembers?.length < 20 &&
                        this.props.hasReadWriteAccess == true &&
                        checkPermission(UserClaim.AdviserPortalNewClientReadWrite) && (
                            <div className="mb-20">
                                <AddNewButton
                                    name="Add additional beneficiary"
                                    onClick={() => {
                                        if (model?.HasTrustAccount && model?.TrustDetail?.TrustCategory == "Absolute") {
                                            this.setState({ showAddAbsoluteBeneficiaryWarningLightbox: true });
                                        } else {
                                            Navigator.navigateTo(Urls.get().AddBeneficiary, {
                                                scrollAfterNavigating: true,
                                                queryParamsObject: { customerid: this.props.id },
                                            });
                                        }
                                    }}
                                />
                            </div>
                        )}
                </div>
                <TrustMemberTable
                    data={(model?.Organisation?.OrganisationMembers || []).filter(
                        (ele) =>
                            ele.Relationships.every((ele) => ele == RelationshipType.Beneficiary) &&
                            ele?.Individual?.ActorCategory == AccountRoleActorCategory.Associate
                    )}
                    type={model?.Organisation?.CustomerType}
                    trustCategory={model?.TrustDetail?.TrustCategory}
                    isCompanyMember={false}
                    isBeneficiaryOnly={true}
                    showShareOfTrust={true}
                    hasAction={this.props.hasReadWriteAccess == true}
                    onDelete={(id) => this.onClickDelete(id, true)}
                    onEdit={(id) => this.setState({ showEditLightbox: true, editItem: id })}
                    onEditRoles={(id) => {}}
                    onClickHistory={(id) => this.onClickHistory(id)}
                    onClickShareofTrust={() => this.onClickShareofTrust()}
                    hasTrustAccount={model?.HasTrustAccount}
                    isTrustServicing={true}
                    histories={this.state.histories}
                    invalidMembers={model?.InactiveMembers}
                    totalTrustees={(trusteeWithNoPendingAction || []).length}
                />
                {showDeleteLightbox && !model?.HasTrustAccount && (
                    <DeleteLightbox
                        onClose={() => this.closeDeleteLightbox()}
                        onDelete={() => {
                            this.onDeleteRelationship();
                        }}
                        content={this.renderRelationshipRemove()}
                    />
                )}
                {showDeleteLightbox && model?.HasTrustAccount && (
                    <RemoveMemberLightbox
                        organisation={organisation}
                        editItem={this.state.deleteItem}
                        organisationMembers={model?.Organisation?.OrganisationMembers}
                        trustCategory={model?.TrustDetail?.TrustCategory}
                        onClose={() => {
                            this.closeDeleteLightbox();
                            this.getData();
                        }}
                        accountId={model?.HierarchyId?.EntityId}
                    />
                )}
                {showEditLightbox && (
                    <EditBeneficiaryLightbox
                        data={editItem?.Individual}
                        onClose={() => this.closeEditLightbox()}
                        onSave={(data) => {
                            this.onEditBeneficiary(data);
                        }}
                    />
                )}
                {showEditRoleLightbox && (
                    <EditRolesLightbox
                        data={(model?.Organisation?.OrganisationMembers || []).filter(
                            (ele) =>
                                !ele.Relationships.includes(RelationshipType.CorporateTrustee) &&
                                !ele.Relationships.every((ele) => ele == RelationshipType.Beneficiary)
                        )}
                        editItem={editItem}
                        onClose={() => this.closeEditRoleLightbox()}
                        onSave={(data, selectedRoles) => {
                            this.onEditRoles(data, selectedRoles);
                        }}
                    />
                )}
                {showCorrespondenceWarningLightbox && (
                    <Lightbox
                        noOverlay={false}
                        noAutofocus={true}
                        show={showCorrespondenceWarningLightbox}
                        title={"Warning"}
                        unclosable={true}
                        onClose={() => {
                            this.setState({ showCorrespondenceWarningLightbox: false });
                        }}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p className="mb-10">
                            Before you remove this Trustee, you must select another address for correspondence to go to.
                            You can change correspondence address from the Roles page.
                        </p>
                        <button
                            className="btn primary  mt-20"
                            onClick={() => {
                                Navigator.navigateTo(
                                    Urls.get().main.PortfolioDashboard({
                                        hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                            HierarchyLevelName.Customer,
                                            Number(this.props.id)
                                        ),
                                    }).roles
                                );
                            }}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}
                {showRemoveLastTrusteeAndCorrespondenceWarningLightbox && (
                    <Lightbox
                        noOverlay={false}
                        noAutofocus={true}
                        show={showRemoveLastTrusteeAndCorrespondenceWarningLightbox}
                        title={"Warning"}
                        unclosable={true}
                        onClose={() => {
                            this.setState({ showRemoveLastTrusteeAndCorrespondenceWarningLightbox: false });
                        }}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p className="mb-10">You must add a new trustee before removing sole Trustee.</p>
                        <p className="mb-10">
                            Before you remove this Trustee, you must select another address for correspondence to go to.
                            You can change correspondence address from the Roles page.
                        </p>
                        <button
                            className="btn primary  mt-20"
                            onClick={() => {
                                Navigator.navigateTo(
                                    Urls.get().main.PortfolioDashboard({
                                        hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                            HierarchyLevelName.Customer,
                                            Number(this.props.id)
                                        ),
                                    }).roles
                                );
                            }}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}
                {showRemoveLastTrusteeWaringLighBox && (
                    <Lightbox
                        noOverlay={false}
                        noAutofocus={true}
                        show={showRemoveLastTrusteeWaringLighBox}
                        title={"Warning"}
                        unclosable={true}
                        onClose={() => {
                            this.setState({ showRemoveLastTrusteeWaringLighBox: false });
                        }}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p className="mb-10">You must add a new trustee before removing sole Trustee.</p>

                        <button
                            className="btn primary  mt-20"
                            onClick={() => {
                                this.setState({ showRemoveLastTrusteeWaringLighBox: false });
                            }}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}
                {showAddAbsoluteBeneficiaryWarningLightbox && (
                    <Lightbox
                        noOverlay={false}
                        noAutofocus={true}
                        show={showAddAbsoluteBeneficiaryWarningLightbox}
                        title={"Warning"}
                        unclosable={true}
                        onClose={() => {
                            this.setState({ showAddAbsoluteBeneficiaryWarningLightbox: false });
                        }}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p className="mb-10">
                            You cannot add Beneficiaries after New Business where Trust category = Absolute.
                        </p>
                        <button
                            className="btn primary  mt-20"
                            onClick={() => {
                                this.setState({ showAddAbsoluteBeneficiaryWarningLightbox: false });
                            }}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}
                {pendingActionWarningMessage != null && (
                    <Lightbox
                        noOverlay={false}
                        noAutofocus={true}
                        show={pendingActionWarningMessage != null}
                        title={"Warning"}
                        unclosable={true}
                        onClose={() => {
                            this.setState({ pendingActionWarningMessage: null });
                        }}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p className="mb-10">{pendingActionWarningMessage}</p>
                        <button
                            className="btn primary  mt-20"
                            onClick={() => {
                                this.setState({ pendingActionWarningMessage: null });
                            }}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}
                {showHistoryLightbox && (
                    <Lightbox
                        noOverlay={false}
                        noAutofocus={true}
                        show={showHistoryLightbox}
                        title={"Client details - Trust member History"}
                        contentAfterTitle={<h4>{model?.TrustDetail?.ClAccountId}</h4>}
                        unclosable={false}
                        onClose={() => {
                            this.setState({ showHistoryLightbox: false });
                        }}
                        cssWrapper="is-default-lightbox"
                    >
                        <TrustMemberHistoryLightbox
                            selectedMember={selectedItem}
                            selectedMemberHistory={
                                this.state.histories.find((x) => x.CustomerId == selectedItem.CustomerId)?.Histories
                            }
                            isLoading={this.state.showHistoryLoading}
                        />
                        <button
                            className="btn primary  mt-20"
                            onClick={() => {
                                this.setState({ showHistoryLightbox: false });
                            }}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}
                {showShareofTrustLightbox && (
                    <ShareofTrustLightbox
                        data={organisation}
                        onClose={() => this.onCloseShareofTrust()}
                        onSave={(data) => {
                            this.onShareofTrust(data);
                            this.getData();
                        }}
                    />
                )}
                {/* {showInactiveMemberWarningLightbox && (
                    <Lightbox
                        noOverlay={false}
                        noAutofocus={true}
                        show={showInactiveMemberWarningLightbox}
                        title={"Warning"}
                        unclosable={true}
                        onClose={() => {
                            this.setState({ showInactiveMemberWarningLightbox: false });
                        }}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p className="mb-10">This member does not have an active role on the account for removal.</p>
                        <button
                            className="btn primary  mt-20"
                            onClick={() => {
                                this.setState({ showInactiveMemberWarningLightbox: false });
                            }}
                        >
                            OK
                        </button>
                    </Lightbox>
                )} */}
                {showAtLeastOneBeneficiaryWarningLightbox && (
                    <Lightbox
                        noOverlay={false}
                        noAutofocus={true}
                        show={showAtLeastOneBeneficiaryWarningLightbox}
                        title={"Warning"}
                        unclosable={true}
                        onClose={() => {
                            this.setState({ showAtLeastOneBeneficiaryWarningLightbox: false });
                        }}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        <p className="mb-10">At least 1 Beneficiary required for the trust account.</p>
                        <button
                            className="btn primary  mt-20"
                            onClick={() => {
                                this.setState({ showAtLeastOneBeneficiaryWarningLightbox: false });
                            }}
                        >
                            OK
                        </button>
                    </Lightbox>
                )}
            </>
        );
    }
}
